import "../../../../../EventsScreen/screens/BetDrawerScreen/components/BetBuilder/components/BetBuilderItem/BetBuilderItem.scss";
type props = {
  marketName: string;
  runnerName: string;
  betType: string;
  index: number;
  numberOfItems: number;
};

const BetBuilderItemDetails: React.FC<props> = ({
  marketName,
  runnerName,
  betType,
  index,
  numberOfItems,
}) => {
  // Used for drawing the vertical line
  const isLastItem = index === numberOfItems - 1;
  const isFirstItem = index === 0;
  const lineCssClass = isLastItem
    ? "bet-builder-item__vertical-line__last"
    : isFirstItem
    ? "bet-builder-item__vertical-line__first"
    : "";

  return (
    <div className={`bet-builder-item`}>
      <span className="bet-builder-item__dot"></span>
      {numberOfItems > 1 && (
        <div
          className={`bet-builder-item__vertical-line ${lineCssClass}`}
        ></div>
      )}
      <div className="bet-builder-item__row">
        <div className="bet-builder-item__content">
          <span className="bet-builder-item__runner-name">{runnerName}</span>
          <span className="bet-builder-item__market-and-period">
            {marketName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BetBuilderItemDetails;
